import type { BrowserWindow, WebContents } from "electron";

import type { IVar } from "@/ivar";
import { in_electron } from "@/utils/in";

export type GetMainWindow = () =>
  | IVar<BrowserWindow>
  | Promise<IVar<BrowserWindow>>;

function runWhenDevtoolsReady(devtools: WebContents, fn: () => void) {
  const isLoading = devtools.isLoadingMainFrame();
  if (isLoading) devtools.once("dom-ready", fn);
  else fn();
}

async function openConsolePanel(getMainWindow: GetMainWindow) {
  const win = await getMainWindow();
  const wc = win.webContents;
  const switchToConsole = () => {
    const devtools = wc.devToolsWebContents;
    if (!devtools) return;
    runWhenDevtoolsReady(devtools, () => {
      devtools
        .executeJavaScript("UI.ViewManager.instance().showView('console-view')")
        .catch(() => void 0);
    });
  };
  if (wc.isDevToolsOpened()) {
    switchToConsole();
  } else {
    wc.once("devtools-opened", switchToConsole);
    wc.openDevTools({ mode: "right", activate: true });
  }
}

export const devtools = {
  initialize(getMainWindow: GetMainWindow) {
    const { ipcMain } = require("electron");
    ipcMain.handle("open-devtools", async () => {
      await openConsolePanel(getMainWindow);
    });
  },

  open() {
    if (!in_electron) return;
    const { ipcRenderer } = require("electron");
    return ipcRenderer.invoke("open-devtools");
  },
};
